import axios from "axios";
import { getBackendUrl } from "../config";

const api = axios.create({
	baseURL: getBackendUrl(),
	withCredentials: true,
});

// Interceptor para tratar erros 404 na API do Kanban
api.interceptors.response.use(
	response => response,
	error => {
		// Se for um erro 404 em uma rota kanban/cards/ticket, não propagamos o erro
		if (error.response && 
			error.response.status === 404 && 
			error.config.url.includes('kanban/cards/ticket')) {
			// Criamos uma resposta "falsa" com dados nulos para que o código continue normalmente
			return Promise.resolve({ data: null });
		}
		// Para outros erros, rejeitamos normalmente
		return Promise.reject(error);
	}
);

export default api;
